/* eslint-disable react/no-unused-class-component-methods */
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var qwest = _interopRequireWildcard(require("qwest"));
var _is_js = _interopRequireDefault(require("is_js"));
var _TextInput = _interopRequireDefault(require("Components/Forms/Elements/TextInput"));
var _TextEditor = _interopRequireDefault(require("Components/Forms/Elements/TextEditor"));
var _Checkbox = _interopRequireDefault(require("Components/Forms/Elements/Checkbox"));
var _Select = _interopRequireDefault(require("Components/Forms/Elements/Select"));
var _Switch = _interopRequireDefault(require("Components/Forms/Elements/Switch"));
var _DatePicker = _interopRequireDefault(require("Components/Forms/Elements/V2/DatePicker"));
var _Delete = _interopRequireDefault(require("@material-ui/icons/Delete"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _Radio = _interopRequireDefault(require("@material-ui/core/Radio"));
var _Tabs = _interopRequireDefault(require("@material-ui/core/Tabs"));
var _Tab = _interopRequireDefault(require("@material-ui/core/Tab"));
var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
var _handleChange = _interopRequireDefault(require("Components/Forms/Functions/handleChange"));
var _getStateFromObject = _interopRequireDefault(require("Components/Forms/Functions/getStateFromObject"));
var _getFormData = _interopRequireDefault(require("Components/Forms/Functions/getFormData"));
var _Loader = _interopRequireDefault(require("Pure/Loader"));
var _uniqid = _interopRequireDefault(require("uniqid"));
var _styles = require("@material-ui/core/styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
let app = window.app;
class CvBackForm extends _react.Component {
  state = {
    status_messages: {},
    slug: document.location.pathname.split('liste-des-cvs/')[1],
    'cv[formation]': [],
    'cv[experience]': [],
    current_tab: 0
  };
  handleChange = _handleChange.default.bind(this);
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    if (props.type === 'update') {
      component.fetchCv();
    }
    component.fetchCandidates();
  }
  fetchCv = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/cv/get-all', {
      candidate_id: state.slug,
      with_count: false
    }).then(function (xhr, response) {
      let update = {};
      update['cv[formation]'] = response.cvs[0]?.formation || [];
      delete response.cvs[0]?.formation;
      update['cv[experience]'] = response.cvs[0]?.experience || [];
      delete response.cvs[0]?.experience;
      update = {
        ...update,
        ...(0, _getStateFromObject.default)({
          data: response.cvs[0],
          model: 'cv'
        })
      };
      component.setState({
        ...update,
        fetch_id: (0, _uniqid.default)(),
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  fetchCandidates = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/candidate/get-all', {
      with_count: false
    }).then(function (xhr, response) {
      component.setState({
        loading: false,
        candidates: response.candidates
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  validate = e => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.loading === true) return;
    component.setState({
      loading: true
    });
    const cv = (0, _getFormData.default)({
      state: state,
      pattern: 'cv['
    });
    const url = props.type === 'update' ? '/cv/update' : '/cv/create';
    qwest.post(url, cv).then(function (xhr, response) {
      if (props.type === 'update') {
        component.fetchCv();
      } else {
        window.setTimeout(function () {
          app.navigateTo('/liste-des-cvs');
        }, 2000);
      }
      component.setState({
        loading: false,
        info: response.info,
        error: undefined,
        warning: undefined,
        status_messages: {}
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  handleRadioChange = event => {
    const component = this,
      props = this.props,
      state = this.state;
    const target = event.target;
    const value = target.value;
    const name = target.name;
    component.setState({
      [name]: value,
      info: undefined,
      error: undefined,
      warning: undefined
    });
  };
  handleTabChange = (event, value) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      current_tab: value,
      info: undefined,
      error: undefined,
      warning: undefined
    });
  };
  addFormation = () => {
    const component = this,
      props = this.props,
      state = this.state;
    let id = (0, _uniqid.default)();
    let formation = state['cv[formation]'];
    formation.push({
      title: '',
      date: '',
      description: '',
      id: id,
      level: '',
      otherlevel: ''
    });
    component.setState({
      'cv[formation]': formation
    });
  };
  deleteFormation = formation_id => {
    const component = this,
      props = this.props,
      state = this.state;
    const formation_filtered = state['cv[formation]'].filter(function (formation) {
      return formation['id'] !== formation_id;
    });
    component.setState({
      'cv[formation]': formation_filtered
    });
  };
  addExperience = () => {
    const component = this,
      props = this.props,
      state = this.state;
    let id = (0, _uniqid.default)();
    let experience = state['cv[experience]'];
    experience.push({
      title: '',
      start_date: '',
      end_date: '',
      description: '',
      id: id
    });
    component.setState({
      'cv[experience]': experience
    });
  };
  deleteExperience = experience_title => {
    const component = this,
      props = this.props,
      state = this.state;
    const experience_filtered = state['cv[experience]'].filter(function (experience) {
      return experience['id'] !== experience_title;
    });
    component.setState({
      'cv[experience]': experience_filtered
    });
  };
  handleFormationChange = ({
    e,
    value,
    name,
    id,
    field_name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    let formation = (state['cv[formation]'] || []).find(formation => formation.id === id);
    formation[field_name] = value;
    component.setState({
      formation: state.formation
    });
  };
  handleExperienceChange = ({
    e,
    value,
    name,
    id,
    field_name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    let experience = (state['cv[experience]'] || []).find(experience => experience.id === id);
    experience[field_name] = value;
    component.setState({
      experience: state.experience
    });
  };
  handleFormationDateChange = ({
    e,
    value,
    name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    let index = name.split('cv[formation][')[1];
    index = index.slice(0, index.indexOf(']'));
    const field = name.slice(name.lastIndexOf('[') + 1).slice(0, -1);
    let formation = (state['cv[formation]'] || [])[index];
    if (formation) {
      formation[field] = value;
      component.setState({
        'cv[formation]': state['cv[formation]']
      });
    }
  };
  handleExpDateChange = ({
    e,
    value,
    name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    let index = name.split('cv[experience][')[1];
    index = index.slice(0, index.indexOf(']'));
    const field = name.slice(name.lastIndexOf('[') + 1).slice(0, -1);
    let experience = (state['cv[experience]'] || [])[Number(index)];
    console.log('handleExpDateChange', index, field, experience);
    if (experience) {
      experience[field] = value;
      component.setState({
        'cv[experience]': state['cv[experience]']
      });
    }
  };
  handleCheckboxChange = ({
    e,
    name,
    value
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    let status_messages = state.status_messages;
    delete status_messages[name];
    if ([true, 'true'].includes(value)) {
      component.setState({
        [name]: value,
        info: undefined,
        error: undefined,
        warning: undefined,
        status_messages: status_messages
      });
    } else {
      delete state[name];
      component.setState({
        info: undefined,
        error: undefined,
        warning: undefined,
        status_messages: status_messages
      });
    }
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const status = (0, _getFormStatus.default)(state);
    const loader = state.loading === true ? /*#__PURE__*/_react.default.createElement(_Loader.default, {
      className: "c-loader",
      bemit: ['white', 'bg-primary']
    }) : undefined;
    let formation_list = (state['cv[formation]'] || []).map(function (formation, index) {
      let output = /*#__PURE__*/_react.default.createElement(_Grid.default, {
        container: true,
        spacing: 3,
        className: "c-background-blue"
      }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 12,
        classes: props.classes
      }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
        onChange: ({
          e,
          value,
          name
        }) => component.handleFormationChange({
          e,
          name,
          value,
          id: formation.id,
          field_name: 'title'
        }),
        value: formation.title,
        name: 'cv[formation][' + index + '][title]',
        type: "text",
        label: "Intitul\xE9 de la formation",
        status: state.status_messages
      })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 6,
        classes: props.classes
      }, /*#__PURE__*/_react.default.createElement(_DatePicker.default, {
        label: "Date de d\xE9but",
        name: 'cv[formation][' + index + '][start_date]',
        onChange: component.handleFormationDateChange,
        value: formation.start_date,
        error: state.status_messages?.['cv[formation][' + index + '][start_date]']?.error,
        key: state.fetch_id
      })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 6,
        classes: props.classes
      }, /*#__PURE__*/_react.default.createElement(_DatePicker.default, {
        label: "Date de fin",
        name: 'cv[formation][' + index + '][end_date]',
        onChange: component.handleFormationDateChange,
        value: formation.end_date,
        error: state.status_messages?.['cv[formation][' + index + '][end_date]']?.error,
        key: state.fetch_id
      })), /*#__PURE__*/_react.default.createElement("p", {
        className: "title-candidate-form"
      }, "Niveau de la formation :"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 3,
        classes: props.classes
      }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
        checked: state['cv[formation]'][index].level === "CAP",
        onChange: ({
          e
        }) => component.handleFormationChange({
          e,
          name: 'cv[formation][' + index + '][level]',
          value: "CAP",
          id: formation.id,
          field_name: 'level'
        }),
        value: "CAP",
        color: "primary",
        name: 'cv[formation][' + index + '][level]',
        inputProps: {
          'aria-label': 'CAP'
        }
      }), "CAP"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 3,
        classes: props.classes
      }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
        checked: state['cv[formation]'][index].level === "BAC",
        onChange: ({
          e
        }) => component.handleFormationChange({
          e,
          name: 'cv[formation][' + index + '][level]',
          value: "BAC",
          id: formation.id,
          field_name: 'level'
        }),
        value: "BAC",
        color: "primary",
        name: 'cv[formation][' + index + '][level]',
        inputProps: {
          'aria-label': 'BAC'
        }
      }), "BAC"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 3,
        classes: props.classes
      }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
        checked: state['cv[formation]'][index].level === "Master",
        onChange: ({
          e
        }) => component.handleFormationChange({
          e,
          name: 'cv[formation][' + index + '][level]',
          value: "Master",
          id: formation.id,
          field_name: 'level'
        }),
        value: "Master",
        color: "primary",
        name: 'cv[formation][' + index + '][level]',
        inputProps: {
          'aria-label': 'Master'
        }
      }), "Master"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 3,
        classes: props.classes
      }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
        checked: state['cv[formation]'][index].level === "Doctorat",
        onChange: ({
          e
        }) => component.handleFormationChange({
          e,
          name: 'cv[formation][' + index + '][level]',
          value: "Doctorat",
          id: formation.id,
          field_name: 'level'
        }),
        value: "Doctorat",
        color: "primary",
        name: 'cv[formation][' + index + '][level]',
        inputProps: {
          'aria-label': 'Doctorat'
        }
      }), "Doctorat"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 3,
        classes: props.classes
      }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
        checked: state['cv[formation]'][index].level === "Formation professionnelle",
        onChange: ({
          e
        }) => component.handleFormationChange({
          e,
          name: 'cv[formation][' + index + '][level]',
          value: "Formation professionnelle",
          id: formation.id,
          field_name: 'level'
        }),
        value: "Formation professionnelle",
        color: "primary",
        name: 'cv[formation][' + index + '][level]',
        inputProps: {
          'aria-label': 'Formation professionnelle'
        }
      }), "Formation professionnelle"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 3,
        classes: props.classes
      }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
        checked: state['cv[formation]'][index].level === "Autre",
        onChange: ({
          e
        }) => component.handleFormationChange({
          e,
          name: 'cv[formation][' + index + '][level]',
          value: "Autre",
          id: formation.id,
          field_name: 'level'
        }),
        value: "Autre",
        color: "primary",
        name: 'cv[formation][' + index + '][level]',
        inputProps: {
          'aria-label': 'Autre'
        }
      }), "Autre"), state['cv[formation]'][index].level === "Autre" ? /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 6,
        classes: props.classes
      }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
        onChange: ({
          e,
          value,
          name
        }) => component.handleFormationChange({
          e,
          name,
          value,
          id: formation.id,
          field_name: 'other_level'
        }),
        value: formation.other_level,
        name: 'cv[formation][' + index + '][other_level]',
        type: "text",
        label: "Autre niveau",
        status: state.status_messages
      })) : undefined, /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 12,
        classes: props.classes
      }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
        onChange: ({
          e,
          value,
          name
        }) => component.handleFormationChange({
          e,
          name,
          value,
          id: formation.id,
          field_name: 'description'
        }),
        value: formation.description,
        name: 'cv[formation][' + index + '][description]',
        label: "Description",
        multiline: true,
        rows: "2",
        "without-headings": true,
        status: state.status_messages
      })), index !== 0 ? /*#__PURE__*/_react.default.createElement("div", {
        className: "u-full-width u-margin-top-25 u-padding-bottom-20 u-text-center"
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        color: "primary",
        variant: "contained",
        size: "large",
        onClick: e => component.deleteFormation(formation.id)
      }, /*#__PURE__*/_react.default.createElement(_Delete.default, null))) : undefined);
      return output;
    });
    let experience_list = (state['cv[experience]'] || []).map(function (experience, index) {
      let output = /*#__PURE__*/_react.default.createElement(_Grid.default, {
        container: true,
        spacing: 3,
        className: "c-background-blue"
      }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 6,
        classes: props.classes
      }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
        onChange: ({
          e,
          value,
          name
        }) => component.handleExperienceChange({
          e,
          name,
          value,
          id: experience.id,
          field_name: 'title'
        }),
        value: experience.title,
        name: 'cv[experience][' + index + '][title]',
        type: "text",
        label: "Titre de mon poste",
        status: state.status_messages
      })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 6,
        classes: props.classes
      }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
        onChange: ({
          e,
          value,
          name
        }) => component.handleExperienceChange({
          e,
          name,
          value,
          id: experience.id,
          field_name: 'company'
        }),
        value: experience.company,
        name: 'cv[experience][' + index + '][company]',
        type: "text",
        label: "Employeur",
        status: state.status_messages
      })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 6,
        classes: props.classes
      }, /*#__PURE__*/_react.default.createElement(_DatePicker.default, {
        label: "Date de d\xE9but",
        name: 'cv[experience][' + index + '][start_date]',
        onChange: component.handleExpDateChange,
        value: experience.start_date,
        error: state.status_messages?.['cv[experience][' + index + '][start_date]']?.error,
        key: state.fetch_id
      })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 6,
        classes: props.classes
      }, /*#__PURE__*/_react.default.createElement(_DatePicker.default, {
        label: "Date de fin",
        name: 'cv[experience][' + index + '][end_date]',
        onChange: component.handleExpDateChange,
        value: experience.end_date,
        error: state.status_messages?.['cv[experience][' + index + '][end_date]']?.error,
        key: state.fetch_id
      })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 6,
        classes: props.classes
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "grid-radio"
      }, "Type\xA0:"), /*#__PURE__*/_react.default.createElement("span", {
        className: "grid-radio u-margin-right-10"
      }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
        checked: state['cv[experience]'][index].type === "Emploi",
        onChange: ({
          e
        }) => component.handleExperienceChange({
          e,
          name: 'cv[experience][' + index + '][type]',
          value: "Emploi",
          id: experience.id,
          field_name: 'type'
        }),
        value: "Emploi",
        color: "primary",
        name: 'cv[experience][' + index + '][type]'
      }), "Emploi"), /*#__PURE__*/_react.default.createElement("span", {
        className: "grid-radio"
      }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
        checked: state['cv[experience]'][index].type === "Stage",
        onChange: ({
          e
        }) => component.handleExperienceChange({
          e,
          name: 'cv[experience][' + index + '][type]',
          value: "Stage",
          id: experience.id,
          field_name: 'type'
        }),
        color: "primary",
        value: "Stage",
        name: 'cv[experience][' + index + '][type]'
      }), "Stage")), /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 12,
        classes: props.classes
      }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
        onChange: ({
          e,
          value,
          name
        }) => component.handleExperienceChange({
          e,
          name,
          value,
          id: experience.id,
          field_name: 'description'
        }),
        value: experience.description,
        name: 'cv[experience][' + index + '][description]',
        label: "R\xE9sum\xE9 de mes fonctions",
        multiline: true,
        rows: "2",
        "without-headings": true,
        status: state.status_messages
      })), index !== 0 ? /*#__PURE__*/_react.default.createElement("div", {
        className: "u-full-width u-margin-top-25 u-padding-bottom-20 u-text-center"
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        color: "primary",
        variant: "contained",
        size: "large",
        onClick: e => component.deleteExperience(experience.id)
      }, /*#__PURE__*/_react.default.createElement(_Delete.default, null))) : undefined);
      return output;
    });
    let candidate_options = (state.candidates || []).map(function (candidate) {
      let option = {
        value: candidate.id,
        label: candidate.firstname + ' ' + candidate.lastname
      };
      return option;
    });
    let output = /*#__PURE__*/_react.default.createElement("form", {
      method: "POST",
      action: "/candidate/create",
      className: "u-full-width"
    }, /*#__PURE__*/_react.default.createElement(_Paper.default, {
      className: "tabs-paper",
      elevation: 2
    }, /*#__PURE__*/_react.default.createElement(_Tabs.default, {
      value: state.current_tab,
      onChange: component.handleTabChange,
      name: "current_tab",
      variant: "scrollable",
      scrollButtons: "auto",
      indicatorColor: "primary",
      textColor: "primary"
    }, /*#__PURE__*/_react.default.createElement(_Tab.default, {
      label: "Informations",
      value: 0
    }), /*#__PURE__*/_react.default.createElement(_Tab.default, {
      label: "Comp\xE9tences & Int\xE9r\xEAts",
      value: 1
    }), /*#__PURE__*/_react.default.createElement(_Tab.default, {
      label: "Formations",
      value: 2
    }), /*#__PURE__*/_react.default.createElement(_Tab.default, {
      label: "Exp\xE9riences",
      value: 3
    }))), /*#__PURE__*/_react.default.createElement(_Paper.default, {
      className: "o-back-content candidate-paper",
      hidden: state.current_tab !== 0,
      elevation: 2
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 3,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Select.default, {
      onChange: component.handleChange,
      value: state['cv[candidate_id]'],
      name: "cv[candidate_id]",
      label: "Candidat",
      status: state.status_messages,
      options: candidate_options,
      "default-value": candidate_options[0]?.value
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['cv[title]'],
      name: "cv[title]",
      type: "text",
      label: "Poste recherch\xE9",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["cv[summary]"] || '',
      name: "cv[summary]",
      label: "R\xE9sum\xE9 de mon profil",
      multiline: true,
      rows: "2",
      "without-headings": true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "Type de contrats :"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 2,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Alternance",
      name: "cv[searched_contract_type][alternance]",
      value: state['cv[searched_contract_type][alternance]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 2,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "CDD",
      name: "cv[searched_contract_type][cdd]",
      value: state['cv[searched_contract_type][cdd]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 2,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "CDI",
      name: "cv[searched_contract_type][cdi]",
      value: state['cv[searched_contract_type][cdi]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 2,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Stage",
      name: "cv[searched_contract_type][stage]",
      value: state['cv[searched_contract_type][stage]'] === true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement("p", {
      className: "title-candidate-form"
    }, "T\xE9l\xE9travail :"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['cv[telecommuting]'] === "Oui",
      onChange: component.handleRadioChange,
      value: "Oui",
      color: "primary",
      name: "cv[telecommuting]",
      inputProps: {
        'aria-label': 'Oui'
      }
    }), "Oui"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 4,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Radio.default, {
      checked: state['cv[telecommuting]'] === "Non",
      onChange: component.handleRadioChange,
      value: "Non",
      color: "primary",
      name: "cv[telecommuting]",
      inputProps: {
        'aria-label': 'Non'
      }
    }), "Non"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Switch.default, {
      onChange: component.handleChange,
      value: state['cv[is_public]'] === true,
      name: "cv[is_public]",
      "top-label": "Publi\xE9 sur le web",
      "left-label": "Non",
      label: "Oui",
      status: state.status_messages
    })))), /*#__PURE__*/_react.default.createElement(_Paper.default, {
      className: "o-back-content candidate-paper",
      hidden: state.current_tab !== 1,
      elevation: 2
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 3,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["cv[expertise_field]"] || '',
      name: "cv[expertise_field]",
      label: "Domaines de comp\xE9tences",
      multiline: true,
      rows: "2",
      "without-headings": true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["cv[soft_skills]"] || '',
      name: "cv[soft_skills]",
      label: "Soft skills",
      multiline: true,
      rows: "2",
      "without-headings": true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["cv[software_and_language]"] || '',
      name: "cv[software_and_language]",
      label: "Logiciels / Langages informatiques ma\xEEtris\xE9s",
      multiline: true,
      rows: "2",
      "without-headings": true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["cv[hobbies]"] || '',
      name: "cv[hobbies]",
      label: "Centre d'int\xE9r\xEAt(s)",
      multiline: true,
      rows: "2",
      "without-headings": true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["cv[language]"] || '',
      name: "cv[language]",
      label: "Langues",
      multiline: true,
      rows: "2",
      "without-headings": true,
      status: state.status_messages
    })))), /*#__PURE__*/_react.default.createElement(_Paper.default, {
      className: "o-back-content candidate-paper",
      hidden: state.current_tab !== 2,
      elevation: 2
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 3,
      classes: props.classes
    }, formation_list, /*#__PURE__*/_react.default.createElement("div", {
      className: "u-full-width u-margin-top-25 u-padding-bottom-20 u-text-center"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      color: "primary",
      variant: "contained",
      size: "large",
      onClick: component.addFormation
    }, "Ajouter une formation")))), /*#__PURE__*/_react.default.createElement(_Paper.default, {
      className: "o-back-content candidate-paper",
      hidden: state.current_tab !== 3,
      elevation: 2
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 3,
      classes: props.classes
    }, experience_list, /*#__PURE__*/_react.default.createElement("div", {
      className: "u-full-width u-margin-top-25 u-padding-bottom-20 u-text-center"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      color: "primary",
      variant: "contained",
      size: "large",
      onClick: component.addExperience
    }, "Ajouter une exp\xE9rience")))), /*#__PURE__*/_react.default.createElement("div", {
      className: "u-full-width u-margin-top-25 u-padding-bottom-20 u-text-center"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      color: "primary",
      variant: "contained",
      size: "large",
      onClick: component.validate
    }, props.type === 'update' ? 'Mettre à jour' : 'Créer le Cv')), status, loader);
    return output;
  }
}
exports.default = CvBackForm;
